<template>
  <div class="swiper" ref="swiper">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(item, index) in list" :key="index" @click="handleClick(item, index)">
        <slot :data="item.url" :item="item" :index="index"></slot>
      </div>
    </div>
    <div class="swiper-pagination"></div>
    <!--分页器。如果放置在swiper外面，需要自定义样式。-->
  </div>
</template>

<script>
import Swiper from "swiper";
import { Navigation, Pagination,Autoplay } from "swiper/modules";
export default {
  name: "",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    bannerDuration: {
      type: Number,
      default: 2000
    }
  },
  methods: {
    handleClick(item, index) {
      this.$emit('slide-click', item, index);
    },
  },
  mounted() {
    new Swiper(this.$refs.swiper, {
      modules: [Navigation, Pagination, Autoplay],
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
      },
      loop: true,
      autoplay: {
        delay: this.bannerDuration,
      }
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.swiper-slide {
  cursor: pointer;
  transition: transform 0.2s ease;

  &:active {
    transform: scale(0.98);
  }
}

::v-deep .swiper-pagination {
  .swiper-pagination-bullet {
    width: 4px;
    height: 4px;
    background: rgba(255, 255, 255, 0.6);
    transition: width 100ms linear;
  }
  .swiper-pagination-bullet-active {
    width: 10px;
    border-radius: 10px;
  }
}
</style>
